import { format, zonedTimeToUtc } from "date-fns-tz";

function getRegionDateTimeInUTC(
  date: Date,
  timeString: string,
  timeZone: string
): Date {
  // get date in YYYY-MM-DD format, without considering time zone
  const ymd = format(date, "yyyy-MM-dd");
  const localISO = `${ymd}T${timeString}:00`;

  // get BFIX date string based on selected region and selected date
  return zonedTimeToUtc(localISO, timeZone);
}

export function getBfixDateString(
  date = new Date(),
  timeString = "09:30:00",
  timeZone = "Asia/Shanghai"
): string {
  const dateInTimeZone = getRegionDateTimeInUTC(date, timeString, timeZone);

  // upstream can't handle .000Z
  return dateInTimeZone.toISOString().replace(".000Z", "Z");
}
